import {
  takeLatest,
  put,
  select,
  all,
} from 'redux-saga/effects';
import { dashboardsSelector } from '@store/tempDashboard/selectors';
import * as types from './types';
import { filterAndApplyState } from '../base/actions';


function sleep(time) {
  return new Promise((resolve) => {
    setTimeout(() => resolve(), time);
  });
}

function* initTempDashboard({ tempDashboardId }) {
  const dashboards = yield select(dashboardsSelector);

  const tempDashboard = dashboards[tempDashboardId];


  if (!tempDashboard || !tempDashboard.dashboard) {
    return;
  }
  yield put({ type: types.START_FETCHING });
  const { dashboard } = tempDashboard;


  try {
    let data = null;
    if (dashboard.nocStore) {
      data = dashboard.nocStore;
    } else if (dashboard.base) {
      data = dashboard.base;
    }


    yield all([
      put(filterAndApplyState(data)),
    ]);
    yield sleep(300);
    yield put({ type: types.END_FETCHING });
  } catch (error) {
    console.error(error);
    throw error;
  }
}

function* watchInitTempDashboard() {
  yield takeLatest([
    types.INIT_TEMP_DASHBOARD,
  ], initTempDashboard);
}

export default [
  watchInitTempDashboard,
];
